const handleApiError = async (response) => {
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('currentUser');
      window.location.reload();
      throw new Error('Oturum süresi doldu veya yetkiniz yok.');
    }
    const errorData = await response.json();
    throw new Error(errorData.message || 'Hata oluştu');
  }
};

export const fetchApartments = async (filters = {}) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/apartments?` + new URLSearchParams(filters), {
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
  });
  await handleApiError(response);
  return response.json();
};

export const addApartment = async (apartmentData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/apartments`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(apartmentData),
  });
  await handleApiError(response);
  return response.json();
};

export const updateApartment = async (apartmentId, apartmentData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/apartments/${apartmentId}`, {
    method: 'PUT',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(apartmentData),
  });
  await handleApiError(response);
  return response.json();
};

export const deleteApartment = async (apartmentId) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/apartments/${apartmentId}`, {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
  });
  await handleApiError(response);
};
